import {Injectable} from '@angular/core';
import {HttpModelConverter} from "../../../../../../core/converter/httpModel.converter";
import {DateConverter} from "../../../../../../common/converter/date.converter";
import {LovValueSummaryConverter} from "../../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter";
import {CamJobSummaryModel} from "../camJobSummary.model";
import {EntityWithAuditMetadataConverter} from "../../../../../../common/converter/entityWithAuditMetadata.converter";
import {PermissionsConverter} from "../../../../../../common/converter/permissions.converter";

@Injectable({
    providedIn: 'root'
})
export class CamJobSummaryConverter extends HttpModelConverter<CamJobSummaryModel> {

    constructor(private dateConverter: DateConverter,
                private lovValueSummaryConverter: LovValueSummaryConverter,
                private entityWithAuditMetadataConverter: EntityWithAuditMetadataConverter,
                private permissionConverter: PermissionsConverter) {
        super();
    }

    protected createInstance(): CamJobSummaryModel {
        return new CamJobSummaryModel();
    }

    protected enrichObject(result: CamJobSummaryModel, src: CamJobSummaryModel) {
        result = this.entityWithAuditMetadataConverter.convert(src, result);
        result.side = this.lovValueSummaryConverter.convert(src.side);
        result.permissions = this.permissionConverter.convert(src.permissions);
    }

}
